import React from 'react';

export default class IndexTableFiltersPanelInput extends React.Component {
    constructor(props) {
        super(props);
    }


    static getInputStateValue = (filter) => {
        return null;
    }

    buildValue(e) {
        return {text: e.target.value, value: e.target.value}
    }

    onKeyUp = e => {
        if (e.key === 'Enter') {
            this.props.onBlur();
        }
    }

    render() {
        return (
            <div className="filters-panel-input">
                <span title={this.props.label}>{this.props.label}</span>
                <span className="filter-single-input">
                    <input
                        type="text"
                        value={this.props.value}
                        onKeyUp={this.onKeyUp}
                        onBlur={() => this.props.onBlur()}
                        onChange={e => this.props.onChange(this.buildValue(e))}
                    />
                </span>
            </div>
        );
    }
}